// src/pages/Developer/DeleteAccount.tsx

import { Link } from 'react-router-dom';
import { DeleteAccountForm } from '@/components/forms/DeleteAccountForm';
import { Card } from 'antd';

/**
 * 注销账号页面
 * ✅ 关键：移除 min-h-screen 和页脚，让 Layout 统一管理布局
 */
export const DeleteAccount = () => {
  return (
    <div className="flex flex-col h-full bg-transparent">
      
      <div className="flex-1 flex flex-col justify-center py-8 px-4 sm:px-6 lg:px-8 w-full max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">注销开发者账号</h1>
          <p className="text-gray-600">请仔细阅读以下说明，确保您了解注销的后果</p>
        </div>

        <Card 
          className="shadow-lg border-0 rounded-xl" 
          styles={{ body: { padding: '32px' } }}
        >
        {/* 注销说明 */}
        <div className="mb-8 p-4 bg-red-50 rounded-lg border border-red-100">
          <h3 className="font-medium text-red-800 mb-2">注销后将删除：</h3>
          <ul className="list-disc list-inside text-sm text-red-700 space-y-1">
            <li>开发者账号及所有个人信息</li>
            <li>所有创建的 App 及密钥</li>
            <li>所有产品及配置数据</li>
            <li>所有上传的面板资源</li>
            <li>所有上传的图片文件</li>
            <li>所有上传的 OTA 固件文件</li>
          </ul>
          <p className="text-red-600 font-medium mt-3">⚠️ 此操作不可撤销，请谨慎操作！</p>
        </div>

          <DeleteAccountForm />
          
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-600">
              改变主意了？{' '}
              <Link 
                to="/profile" 
                className="font-medium text-blue-600 hover:text-blue-500 transition-colors"
              >
                返回个人信息页
              </Link>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};